import styled from 'styled-components'

const StSelectListItemContainer = styled.label<{ $disabled?: boolean }>`
  &:hover {
    cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};

    > div {
      transition-property: border, background, color;
      transition-duration: 175ms;

      ${({ $disabled, theme }) =>
        !$disabled &&
        `
        background-color: ${theme.Components.Conversational.ActiveFill};
        color: ${theme.Components.Conversational.ActiveText};
      `}
    }
  }

  > input {
    display: none;
  }

  > div {
    border: 1px solid ${({ theme }) => theme.Components.Conversational.Border};
    border-radius: ${({ theme }) => theme.UI.BorderRadius.Small}px;
    background-color: ${({ theme }) => theme.Components.Conversational.Fill};
    color: ${({ theme }) => theme.Components.Conversational.Text};

    padding: ${({ theme }) => `${theme.UI.SpacingPx.Space3} ${theme.UI.SpacingPx.Space4}`};

    transition: all 175ms ease-out;

    ${({ $disabled }) => $disabled && 'opacity: 0.5;'}
  }

  input:checked + div {
    border-color: ${({ theme }) => theme.Components.Conversational.ActiveBorder};

    background-color: ${({ theme }) => theme.Components.Conversational.ActiveFill};
    color: ${({ theme }) => theme.Components.Conversational.ActiveText};
  }

  input:disabled + div {
    opacity: 0.4;
    cursor: default;
  }

  &:has(input:disabled):hover {
    cursor: default;

    > div {
      background-color: ${({ theme }) => theme.Components.Conversational.Fill};
      color: ${({ theme }) => theme.Components.Conversational.Text};
    }
  }
`

const StAside = styled.aside`
  color: ${({ theme }) => theme.Colors.Status.Error};
`

export { StAside, StSelectListItemContainer }
